module.exports = __webpack_public_path__ + "img/ico-request-accepted.48e59beb.svg";